import React from 'react';

export default function HeaderBackground({ scrollProgress }) {
  return (
    <>
      <div 
        className="absolute inset-0 transition-all duration-500"
        style={{
          background: scrollProgress === 0 
            ? 'rgba(253, 246, 233, 0.95)' // Match hero background color
            : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: `blur(${8 + scrollProgress * 4}px)`,
          borderBottom: scrollProgress > 0 
            ? '1px solid rgba(185, 28, 28, 0.1)'
            : 'none',
          boxShadow: scrollProgress > 0
            ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            : 'none'
        }}
      />

      {/* Decorative gradient line */}
      <div 
        className="absolute bottom-0 left-0 right-0 h-px transition-opacity duration-300"
        style={{
          opacity: scrollProgress,
          background: 'linear-gradient(to right, transparent, rgba(185, 28, 28, 0.2), transparent)'
        }}
      />
    </>
  );
}